import { render, staticRenderFns } from "./NormalSearchNav304.vue?vue&type=template&id=5b4847a0&scoped=true"
import script from "./NormalSearchNav304.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav304.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4847a0",
  null
  
)

export default component.exports